import { useLanguage } from "@/contexts/LanguageContext";

const SocialProofStats = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {/* Big savings */}
          <div className="text-center p-8 rounded-2xl bg-card border border-primary/20 shadow-lg">
            <div className="text-5xl md:text-6xl font-extrabold text-primary mb-3">€17K</div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs mx-auto">
              {t.hero.stats.avgSavings}
            </p>
          </div>
          {/* Properties analyzed */}
          <div className="text-center p-8 rounded-2xl bg-card border border-border shadow-lg">
            <div className="text-5xl md:text-6xl font-extrabold text-foreground mb-3">50,000+</div>
            <p className="text-sm text-muted-foreground">
              {t.hero.stats.properties}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofStats;
